var map = {
	"./Bayar": 25195,
	"./Bayar.js": 25195,
	"./Daftarantri": 17503,
	"./Daftarantri.js": 17503,
	"./Fotopasien": 30647,
	"./Fotopasien.js": 30647,
	"./Periksa": 353,
	"./Periksa.js": 353,
	"./Previewasuransi": 53749,
	"./Previewasuransi.js": 53749,
	"./Rekammedis": 29497,
	"./Rekammedis.js": 29497,
	"./Setrole": 98673,
	"./Setrole.js": 98673,
	"./_Template": 55390,
	"./_Template.js": 55390
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5025;